/* ============================================================================
 * Movatic WMS - Mobile | Scan (Leitura rapida) | CesarFilho 932048016
 * Delega no layout base scan-driven unificado (ADR-0034 F3).
 * Modo 'continuo': rajada -> rearma a cada leitura, arranca a ler.
 * ========================================================================== */

import ColetorScanScreen from '../components/ColetorScanScreen'

export default function MobileScan() {
  return <ColetorScanScreen mode="continuo" titulo="Leitura rapida" />
}
